<template>
  <div :class="['input-file-ui', isSelected && 'input-file-ui--filled']">
    <input
      id="fileElem"
      ref="fileSelector"
      type="file"
      class="input-file-ui__input"
      :accept="accept"
      :disabled="disabled"
      @change="onChange"
    />
    <div class="input-file-ui__content">
      <div class="input-file-ui__info">
        <p v-if="isSelected" class="input-file-ui__title">{{ title }}</p>
        <VFallbackText v-else class="straight">No file chosen</VFallbackText>
      </div>
      <VBtn for="fileElem" tag="label">{{ btnTitle }}</VBtn>
    </div>
  </div>
</template>

<script lang="ts" setup>
  // Components
  import VBtn from '~/misc/v-btn';
  import VFallbackText from '~/misc/v-fallback-text/VFallbackText.vue';

  const props = defineProps({
    btnTitle: {
      type: String,
      default: 'Choose file',
    },
    accept: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resetTrigger: {
      type: Number,
      default: undefined,
    },
  });

  const emit = defineEmits<{
    (e: 'select', file: File | null): void;
  }>();

  const isSelected: Ref<boolean> = ref<boolean>(false);
  const title: Ref<string> = ref<string>('');

  const fileSelector: Ref<HTMLInputElement | null> = ref<HTMLInputElement | null>(null);

  const setIsSelected = (value: boolean) => {
    isSelected.value = value;
  };

  const setTitle = (value: string) => {
    title.value = value;
  };

  const onChange = (event: Event) => {
    const files: FileList | null = (event.target as HTMLInputElement).files;
    const file: File | null = files?.length ? files[0] : null;

    if (file) {
      setTitle(file.name);
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }

    emit('select', file);
  };

  watch(
    () => props.resetTrigger,
    () => {
      if (fileSelector.value) {
        setIsSelected(false);

        fileSelector.value.value = '';
      }
    }
  );
</script>
